import { useSelector } from 'react-redux';
import { useObserver } from './ObserverHooks';
export function useItemSelectedState(isSelected, selectable) {
    if (!isSelected) {
        return undefined;
    }
    const multiSelectIsActive = selectable !== null &&
        useSelector((state) => state.Storage.MULTISELECT && Object.keys(state.Storage.MULTISELECT).length > 0);
    const selected = !!useObserver({ observer: isSelected });
    return multiSelectIsActive ? (selected ? 'on' : 'off') : undefined;
}
export function useSelectedRowCount() {
    return useSelector((state) => { var _a; return Object.keys((_a = state.Storage.MULTISELECT, (_a !== null && _a !== void 0 ? _a : {}))).filter((k) => !k.startsWith('_')).length; });
}
